import React from 'react';
import { withRouter } from 'react-router-dom';
import { inject } from 'mobx-react';
import strings from '../../lang/strings.js';
import { PageSettings } from "../../config/page-settings";
import { Panel, PanelBody } from '../../components/panel/panel.jsx';
import { Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import './../../config/util';
import MemberDetailPopup from './../member-detail/member-detail-popup'
import MemberPathFragment from './path-fragment'
import MemberPathSta from './path-sta'
const queryString = require('query-string');

class MemberPath extends React.Component {
    static contextType = PageSettings;

    constructor(props) {
        super(props);
        this.state = {
        };

        this.toggle = this.toggle.bind(this);
        this.showMemberDetailPopup = this.showMemberDetailPopup.bind(this);
    }

    componentDidMount() {
    }

    toggle(tab) {
        this.props.history.push('?gender=' + tab);
    }

    showMemberDetailPopup(uid) {
        this.setState({
            show_member_profile: true,
            selected_uid: uid
        });
    }

    render() {
        const searchQS = queryString.parse(this.props.location.search);
        const tab = searchQS.gender || '';

        return (
            <div>
                <div className="row">
                    <div className="col-xs-12">
                        <MemberPathSta />
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <Panel>
                            <Nav tabs className="nav-tabs-inverse">
                                <NavItem>
                                    <NavLink className={classnames({ active: tab === '' })} onClick={() => { this.toggle(''); }}>
                                        <span className="d-none d-xs-inline">{strings.total}</span>
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink className={classnames({ active: tab === 'M' })} onClick={() => { this.toggle('M'); }}>
                                        <span className="d-none d-xs-inline">{strings.male} {strings.signup_path}</span>
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink className={classnames({ active: tab === 'F' })} onClick={() => { this.toggle('F'); }}>
                                        <span className="d-none d-xs-inline">{strings.female} {strings.signup_path}</span>
                                    </NavLink>
                                </NavItem>
                            </Nav>
                            <PanelBody>
                                <MemberDetailPopup isOpen={this.state.show_member_profile} uid={this.state.selected_uid} onClose={() => {
                                    this.setState({ show_member_profile: false });
                                }} />

                                {tab === "" && (<MemberPathFragment gender={tab} onClickRow={this.showMemberDetailPopup} />)}
                                {tab === "M" && (<MemberPathFragment gender={tab} onClickRow={this.showMemberDetailPopup} />)}
                                {tab === "F" && (<MemberPathFragment gender={tab} onClickRow={this.showMemberDetailPopup} />)}
                            </PanelBody>
                        </Panel>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(inject('rootStore')(MemberPath));